import PruebasList from "../components/PruebasList";

// ✅ Componente con nombre
const DiagnosticoPage = () => (
  <section className="container mx-auto px-4 py-8">
    <h1 className="text-2xl font-bold">Pruebas de diagnóstico</h1>

    {/* Texto explicativo opcional */}
    <p className="text-gray-600 mb-6">
      Mide tu nivel actual de preparación con esta prueba de diagnóstico especialmente diseñada para ti. Consiste de solo 15 ejercicios con una duración de 50 minutos.
    </p>

    <PruebasList tipo="diagnostico" />
  </section>
);

// ✅ Exporta el componente ya nombrado
export default DiagnosticoPage;
